import React, { useState, useEffect, useRef, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
// import Header from "./Header";
import { IoMdClose } from "react-icons/io";
import { IconContext } from "react-icons";
import { Button } from "@material-ui/core";

// import logo from "../assets/images/Logo.png";
// import profilePic from "../assets/images/userImage.png";
import "../assets/css/settings.css";
import { Link } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import axios from "axios";
import Global from "../global";
import csc from "country-state-city";
import Loader from "react-loader-spinner";
import { toast, ToastContainer } from "react-toastify";
import { ProgressBar } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import "yup-phone";
import { object } from "yup/lib/locale";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import _ from "lodash";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
  DatePicker,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";
import Select from "react-select";
import User from "../assets/images/user.png";
import { GlobalContext } from "../context/Context";
import { VscEyeClosed, VscEye } from "react-icons/vsc";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiInputBase-root": {
      padding: 0,
      backgroundColor: "#fff",

      "& .MuiInputBase-input": {
        padding: 15,
        // borderRadius: 15,

        backgroundColor: "#fff",
      },
    },
  },
  backButton: {
    marginRight: theme.spacing(1),
  },

  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const genderOptions = [
  {
    value: "Male",
    label: "Male",
  },
  {
    value: "Female",
    label: "Female",
  },
  { value: "Other", label: "Other" },
];
const requiredField = <span style={{ color: "red" }}>*</span>;

const Settings = (props) => {
  // console.log("settings props", props);
  const [progress, setProgress] = useState("");
  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(true);

  const [countries, setCountries] = useState([{ name: "Choose Country" }]);
  const [states, setStates] = useState([{ name: "Choose State" }]);
  const [cities, setCities] = useState([{ name: "Choose City" }]);
  const [field, addField] = useState(false);
  const [refresh, setRefresh] = useState("");
  // const [image_url, setImage_url] = useState(User);
  const [user, setUser] = useState({});
  const aadhaarRegex = "^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$";
  const hiddenFileInput = React.useRef(null);
  const [securetext, setSecuretext] = useState(true);
  const [securetext2, setSecuretext2] = useState(true);
  const classes = useStyles();
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  const config2 = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  };

  const { image_url, setImage_url } = useContext(GlobalContext);

  // console.log("context data", image_data);
  useEffect(() => {
    const country = csc.getAllCountries();
    const state = csc.getStatesOfCountry("IN");
    const city = csc.getCitiesOfCountry("IN");
    setCountries([...countries, ...country]);
    // console.log("refreshh");
    async function fetchUser() {
      try {
        const response = await axios.post(
          Global.base_url + "/user/profile",
          null,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        // console.log(response);

        if (response.status === 200) {
          setLoading(false);
          setStates([...states, ...state]);
          setCities([...cities, ...city]);

          setUser(response.data.data);

          try {
            const imageResponse = await axios.post(
              Global.base_url + "/user/profile/image/load",
              null,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                responseType: "blob",
              }
            );
            // console.log(response);

            if (imageResponse.status === 200) {
              // setImage_url(imageResponse.data);
              let imageBlob = URL.createObjectURL(imageResponse.data);
              console.log("image get reponse", imageBlob);
              // toast.error("Image success");
              setImage_url(imageBlob);
            }
          } catch (error) {
            if (error.imageResponse) {
              if (error.imageResponse.status === 401) {
                toast.error("Unable to get User image");
                console.log("admin user error", error);
                return;
              }
            }
          }

          console.log("Profile details", response);

          return;
        }
      } catch (error) {
        if (error.response) {
          if (
            error.response.status === 401 &&
            error.response.data.code === 401
          ) {
            console.log("admin user error", error);
            return;
          }
        }
      }
    }

    fetchUser();
  }, [refresh]);
  // console.log("User", user);
  const FILE_SIZE = 5000000;
  const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg"];
  const handleChange = async (event) => {
    // setUploader(true);
    const files = event.target.files;

    if (files.length === 0) {
      // console.log("cancelled");
      return null;
    }
    // console.log("upload file", files);
    // console.log(eventId);
    // setLoading(true);
    // console.log(files[0].type.split("/")[1]);

    if (
      !(
        files[0].type.split("/")[1] === "jpg" ||
        files[0].type.split("/")[1] === "jpeg" ||
        files[0].type.split("/")[1] === "png"
      )
    ) {
      return toast.error("Please upload a jpg/jpeg/png file");
    }

    const formData = new FormData();
    formData.append("user_image", files[0], `user-${user.user_id}`);

    console.log("upload image", files[0]);
    try {
      const response = await axios.post(
        Global.base_url + "/user/profile/image",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          onUploadProgress: (data) => {
            // console.log("progress", data.loaded / data.total);
            setProgress(Math.floor((100 * data.loaded) / data.total));
          },
        }
      );
      // console.log(response);
      if (response.status === 200) {
        setRefresh(Date.now() + 1);
        toast.success("User image Updated ..");
      }
      // return setUploader(false);
    } catch (error) {
      console.log("error", error);
      if (error.response && error.response.status === 401) {
        toast.error("Image upload failed");
      }
      // setUploader(false);
    }
  };

  const validationSchema = yup.object({
    firstname: yup.string().required("Firstname cannot be empty"),
    lastname: yup.string().required("Lastname cannot be empty"),
    gender: yup.object().required("Please select Gender").nullable(),
    country: yup.string().required("Please select Country"),
    state: yup.string().required("Please select State"),
    city: yup.string().required("Please select City"),
    address: yup.string().required("Street address cannot be empty"),
    pincode: yup.string().required("Pincode cannot be empty"),
    phone: yup.string().phone().required("Phone cannot be empty"),
    dob: yup
      .date()
      .max(
        moment().format("YYYY-MM-DD"),
        "Date must be earlier than today's date"
      )
      .required("DOB is required")
      .nullable(),
    oldPassword: yup
      .string()
      .min(8, "Old password must be at least 8 characters")
      .max(15),
    newPassword: yup.string().when("oldPassword", (oldPassword) => {
      if (oldPassword)
        return yup
          .string()
          .required("New password cannot be empty")
          .notOneOf(
            [yup.ref("oldPassword"), ""],
            "New password must not be same as old password"
          )
          .notOneOf(["password"], "Password must not be 'password'")
          .min(8)
          .max(15);
    }),
    confirmPwd: yup
      .string()
      .when(["oldPassword", "newPassword"], (oldPassword, newPassword) => {
        if (oldPassword || newPassword)
          return yup
            .string()
            .required("Confirm password cannot be empty")
            .oneOf(
              [yup.ref("newPassword")],
              "Confirm password must be same as new password"
            )
            .min(8)
            .max(15);
      }),
  });
  const initialValues = {
    firstname: user.first_name,
    lastname: user.last_name,
    country: user.country,
    state: user.state,
    city: user.district,
    gender: { value: user.gender, label: user.gender },
    // email_id: user.email_id,
    // aadhaar: user.aadhaar,
    phone: user.phone_no,
    dob:
      user.dob !== null
        ? moment(user.dob, "YYYY-MM-DD'T'HH:mm:ss.SSS'Z'")
        : null,
    address: user.address,
    pincode: user.pincode,
    oldPassword: "",
    newPassword: "",
    confirmPwd: "",
  };
  const getAllStates = (ct) => {
    // console.log("country", ct);
    const country = countries.find((c) => c.name === ct);

    setStates([...csc.getStatesOfCountry(country.isoCode)]);
  };
  const getAllCities = (st) => {
    // console.log("country", st);
    const state = states.find((s) => s.name === st);
    // console.log("state", state.length);
    setCities([...csc.getCitiesOfState(state.countryCode, state.isoCode)]);
  };

  return (
    <>
      {/* <Header
        settings={user.first_name !== undefined ? 0 : 1}
        username={user.first_name + " " + user.last_name}
      /> */}
      <>
        <section className="main__container p-4">
          <>
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={true}
              // newestOnTop={false}
              closeOnClick
              rtl={false}
            />
            {/* <div className="col-12 mt-3">
                      <div className="d-flex flex-row justify-content-between align-items-center">
                        <h3 className="Heading__Text">SETTINGS</h3>
                        <IconContext.Provider value={{ size: "25px" }}>
                          <IoMdClose
                            onClick={() => props.history.push("/userDashboard")}
                          />
                        </IconContext.Provider>
                      </div>
                    </div> */}
            <h3 className="semiFont avator__userName">
              {`${user.first_name} ${user.last_name}`}
            </h3>
            <div>
              <div
                className="image__container mt-3"
                style={{ position: "relative" }}
              >
                <div>
                  <div className="image_container ">
                    <img
                      src={image_url}
                      alt="user"
                      className="profile_image shadow"
                    />
                  </div>
                  {progress > 0 && progress < 100 && (
                    <ProgressBar now={progress} label={`${progress} %`} />
                  )}
                </div>

                <div style={{ marginLeft: "15px" }}>
                  <Button
                    // variant="contained"
                    // color="primary"
                    className={"tab__items"}
                    style={{ width: "auto" }}
                    //   disabled={true}
                    onClick={() => hiddenFileInput.current.click()}
                  >
                    Change Photo
                  </Button>
                </div>
              </div>
              {/* <div className="image-error-position">
                  {formik.errors.user_image && (
                    <p className="error mt-3 ">{formik.errors.user_image}</p>
                  )}
                </div> */}
            </div>

            <input
              type="file"
              ref={hiddenFileInput}
              // onChange={(e) => {
              //   return e.currentTarget.files.length
              //     ? formik.setFieldValue(
              //         "user_image",
              //         e.currentTarget.files[0]
              //       )
              //     : null;
              // }}
              onChange={handleChange}
              style={{ display: "none" }}
              accept="image/*"
            />

            <section className="tab__container mt-5 d-flex">
              <Button
                className={active === 0 ? "tab__items--active" : "tab__items"}
                variant={active === 0 ? "contained" : ""}
                onClick={() => setActive(0)}
              >
                Personal
              </Button>
              <Button
                className={active === 1 ? "tab__items--active" : "tab__items"}
                onClick={() => setActive(1)}
                variant={active === 1 ? "contained" : ""}
              >
                Address
              </Button>
              <Button
                className={active === 2 ? "tab__items--active" : "tab__items"}
                onClick={() => setActive(2)}
                variant={active === 2 ? "contained" : ""}
              >
                Security
              </Button>
            </section>

            <Formik
              initialValues={initialValues}
              enableReinitialize
              validationSchema={validationSchema}
              validateOnChange={false}
              onSubmit={async (values, formik) => {
                // console.log("submiit");
                console.log(values);

                if (values.newpassword && values.oldpassword === "") {
                  return formik.setFieldError(
                    "oldpassword",
                    "old password is required"
                  );
                }
                values.dob = moment(values.dob).format("YYYY-MM-DD");
                formik.setSubmitting(true);

                // formData.append(
                //   "user_image",y
                //   values.user_image,
                //   `user-${user.user_id}`
                // );

                // return;
                try {
                  const response = await axios.post(
                    Global.base_url + "/user/profile/update",
                    { ...values, gender: values.gender.value },
                    config2
                  );
                  // console.log(response);

                  if (response.status === 200) {
                    formik.resetForm(initialValues);
                    toast.success("User details Updated");
                    // formik.setSubmitting(false);
                    return setRefresh(Date.now() + 1);
                  }
                } catch (error) {
                  if (error.response && error.response.status === 401) {
                    toast.error(error.response.data.msg);
                  }
                  if (error.response && error.response.status === 403) {
                    if (error.response.data.code === 1) {
                      formik.setFieldError(
                        "oldpassword",
                        "old password mismatch"
                      );
                    }
                    /*  if (error.response.data.code === 2) {
                      formik.setFieldError(
                        "aadhaar",
                        "Aadhaar already registered"
                      );
                    } */
                    formik.setSubmitting(false);
                    return console.log(error);
                  }
                }
              }}
            >
              {(formik) => {
                // console.log("values", formik.errors);

                return (
                  <>
                    {active === 0 ? (
                      <div className="active__container mt-4">
                        <div className="row m-0 ">
                          <div className="col-12 p-0">
                            {/* <div className="row">
                        <div className=" col-11 offset-1 col-sm-10 offset-sm-2 col-md-12 offset-md-0">
                          <h6 className="">{requiredField} required Fields</h6>
                        </div>
                      </div> */}

                            <div className="row align-767">
                              <div className="col-lg-6 col-xl-6 col-md-6  col-12">
                                <div
                                  className="inputBox"
                                  style={{
                                    position: "relative",
                                    marginTop: 0,
                                    marginBottom: "10px",
                                  }}
                                >
                                  <label
                                    htmlFor="firstname"
                                    className="semiFont login__label"
                                  >
                                    First Name {requiredField}
                                  </label>
                                  <input
                                    type="text"
                                    value={formik.values.firstname}
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        "firstname",
                                        e.currentTarget.value.replace(
                                          /[^a-zA-Z ]/g,
                                          ""
                                        )
                                      );
                                    }}
                                    style={{
                                      border: formik.errors.firstname
                                        ? "1px solid red"
                                        : "1px solid #c3cad9",
                                      marginTop: "5px",
                                      width: "auto",
                                    }}
                                    id="Firstname"
                                    aria-describedby="firstname"
                                    placeholder="First name"
                                  />
                                  {formik.errors.firstname && (
                                    <p className="err">
                                      {formik.errors.firstname}
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-6 col-xl-6 col-md-6  col-12">
                                <div
                                  className="inputBox"
                                  style={{
                                    position: "relative",
                                    marginTop: 0,
                                    marginBottom: "10px",
                                  }}
                                >
                                  <label
                                    htmlFor="lastname"
                                    className="semiFont login__label"
                                  >
                                    Last Name {requiredField}
                                  </label>
                                  <input
                                    type="text"
                                    value={formik.values.lastname}
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        "lastname",
                                        e.currentTarget.value.replace(
                                          /[^a-zA-Z ]/g,
                                          ""
                                        )
                                      );
                                    }}
                                    style={{
                                      border: formik.errors.lastname
                                        ? "1px solid red"
                                        : "1px solid #c3cad9",
                                      marginTop: "5px",
                                      width: "auto",
                                    }}
                                    id="lastname"
                                    aria-describedby="lastname"
                                    placeholder="last name"
                                  />
                                  {formik.errors.lastname && (
                                    <p className="err">
                                      {formik.errors.lastname}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-12 p-0">
                            <div className="row align-767 ">
                              <div className="col-lg-6 col-xl-6 col-md-6  col-12">
                                <div
                                  className="inputBox"
                                  style={{
                                    position: "relative",
                                    marginTop: 0,
                                    marginBottom: "10px",
                                  }}
                                >
                                  <label
                                    htmlFor="dob"
                                    className="semiFont login__label"
                                  >
                                    Date of Birth {requiredField}
                                  </label>
                                  <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <DatePicker
                                      inputVariant="filled"
                                      disableFuture
                                      openTo="year"
                                      className={classes.root}
                                      InputProps={{
                                        disableUnderline: true,
                                      }}
                                      format="DD/MM/YYYY"
                                      views={["year", "month", "date"]}
                                      value={formik.values.dob}
                                      onChange={(date) =>
                                        formik.setFieldValue("dob", date)
                                      }
                                      style={{
                                        border: formik.errors
                                          ? formik.errors.dob
                                            ? "1px solid red"
                                            : "#c3cad9"
                                          : "#c3cad9",
                                        borderRadius: "5px",
                                      }}
                                      error={false}
                                      helperText={null}
                                      placeholder="DD/MM/YYYY"
                                    />
                                  </MuiPickersUtilsProvider>
                                  {formik.errors.dob && (
                                    <p className="err">{formik.errors.dob}</p>
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-6 col-xl-6 col-md-6  col-12">
                                <div
                                  className="inputBox"
                                  style={{
                                    position: "relative",
                                    marginTop: 0,
                                    marginBottom: "10px",
                                  }}
                                >
                                  <label
                                    htmlFor="phone"
                                    className="semiFont login__label"
                                  >
                                    Phone {requiredField}
                                  </label>
                                  <input
                                    type="tel"
                                    value={formik.values.phone}
                                    onChange={(e) =>
                                      formik.setFieldValue(
                                        "phone",
                                        e.currentTarget.value.replace(
                                          /[^0-9]/g,
                                          ""
                                        )
                                      )
                                    }
                                    style={{
                                      border: formik.errors.phone
                                        ? "1px solid red"
                                        : "1px solid #c3cad9",
                                      marginTop: "5px",
                                      width: "auto",
                                    }}
                                    id="phone"
                                    aria-describedby="phone"
                                    placeholder="7012345667"
                                  />
                                  {formik.errors.phone && (
                                    <p className="err">{formik.errors.phone}</p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 p-0">
                            <div className="row">
                              <div className="col-lg-6 col-xl-6 col-md-6  col-12">
                                <div
                                  className="inputBox"
                                  style={{
                                    position: "relative",
                                    marginTop: 0,
                                    marginBottom: "10px",
                                  }}
                                >
                                  <label
                                    htmlFor="gender"
                                    className="semiFont login__label"
                                    style={{
                                      marginBottom: "5px",
                                    }}
                                  >
                                    Gender {requiredField}
                                  </label>
                                  <Select
                                    value={formik.values.gender}
                                    onChange={(p) => {
                                      formik.setFieldValue("gender", p);
                                    }}
                                    id="inputDropdown"
                                    placeholder="Select Gender"
                                    options={genderOptions}
                                    styles={{
                                      control: (base, state) => ({
                                        ...base,
                                        marginTop: "5px",
                                        padding: "8px",
                                        border: formik.errors.gender
                                          ? "1px solid red"
                                          : "1px solid #c3cad9",
                                        "&:active": {
                                          outline: "none",
                                          boxShadow: "none",
                                        },
                                        "&:hover": {
                                          outline: "none",
                                          boxShadow: "none",
                                        },
                                      }),
                                      option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isFocused
                                          ? "#eee"
                                          : "#fff",
                                        padding: "8px",
                                        display: "flex",
                                        fontFamily: "semiFont",
                                        alignItems: "center",
                                        fontSize: "16px",
                                        zIndex: 9999,
                                        color: state.isFocused
                                          ? "#183b56"
                                          : "#183b56",
                                        "&:hover": {
                                          backgroundColor: state.isFocused
                                            ? "#eee"
                                            : "#fff",
                                        },
                                      }),
                                    }}
                                    className="admin__Addproduct--dropdown "
                                  />
                                  {formik.errors.gender && (
                                    <div className="err">
                                      <p>{formik.errors.gender}</p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-2 ml-2">
                          <Button
                            className={
                              formik.dirty
                                ? "primary__btn"
                                : "primary__btn--disabled"
                            }
                            type="contained"
                            style={{
                              padding: "8px 30px",
                              color: formik.dirty
                                ? "#fff"
                                : "rgba(0, 0, 0, 0.26)",
                            }}
                            disabled={!formik.dirty}
                            onClick={function (e) {
                              formik.handleSubmit();
                            }}
                          >
                            Update
                          </Button>
                        </div>
                      </div>
                    ) : null}

                    {active === 1 ? (
                      <div className="active__container mt-4">
                        <div className="row m-0">
                          <div className="col-12 p-0">
                            <div className="row align-767 ">
                              <div className="col-lg-6 col-xl-6 col-md-6  col-12">
                                <div
                                  className="inputBox"
                                  style={{
                                    position: "relative",
                                    marginTop: 0,
                                    marginBottom: "10px",
                                  }}
                                >
                                  <label
                                    htmlFor="address"
                                    className="semiFont login__label"
                                  >
                                    Street address {requiredField}
                                  </label>
                                  <textarea
                                    id="address"
                                    rows="6"
                                    style={{
                                      border: formik.errors.address
                                        ? "1px solid red"
                                        : "1px solid #c3cad9",
                                      marginTop: "5px",
                                      width: "auto",
                                      resize: "none",
                                      borderRadius: "8px",
                                      padding: "10px",
                                      color: "#183b56",
                                      fontSize: "17px",
                                      fontFamily: "mediumFont",
                                    }}
                                    value={formik.values.address}
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        "address",
                                        e.currentTarget.value.replace(
                                          /[^a-zA-Z0-9-_+.,:/' ]/g,
                                          ""
                                        )
                                      );
                                    }}
                                  ></textarea>
                                  {formik.errors.address && (
                                    <p className="err">
                                      {formik.errors.address}
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-6 col-xl-6 col-md-6  col-12">
                                <div
                                  className="inputBox mt-1"
                                  style={{
                                    position: "relative",
                                    marginTop: 0,
                                    marginBottom: "10px",
                                  }}
                                >
                                  <label
                                    htmlFor="country"
                                    className="semiFont login__label"
                                  >
                                    Country {requiredField}
                                  </label>
                                  <Select
                                    value={{
                                      label: formik.values.country,
                                      value: formik.values.country,
                                    }}
                                    onChange={(p) => {
                                      getAllStates(p.value);
                                      formik.setFieldValue("country", p.value);
                                      formik.setFieldValue("state", null);
                                      formik.setFieldValue("city", null);
                                    }}
                                    // defaultValue=""
                                    options={countries.map((c) => {
                                      return { value: c.name, label: c.name };
                                    })}
                                    id="inputDropdown"
                                    name="country"
                                    // className="admim__Addproduct--dropdown "
                                    placeholder="Select Country"
                                    onLoad={(p) => getAllStates(p.value)}
                                    // id="state"
                                    styles={{
                                      control: (base, state) => ({
                                        ...base,
                                        marginTop: "5px",
                                        padding: "10px 10px",
                                        border: formik.errors.country
                                          ? "1px solid red"
                                          : "1px solid #c3cad9",
                                        // border: "1px solid #red",
                                        "&:active": {
                                          outline: "none",
                                          boxShadow: "none",
                                        },
                                        "&:hover": {
                                          outline: "none",
                                          boxShadow: "none",
                                        },
                                      }),
                                      option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isFocused
                                          ? "#eee"
                                          : "#fff",
                                        padding: "8px",
                                        display: "flex",
                                        fontFamily: "semiFont",
                                        alignItems: "center",
                                        fontSize: "16px",
                                        zIndex: 9999,
                                        color: state.isFocused
                                          ? "#183b56"
                                          : "#183b56",
                                        "&:hover": {
                                          backgroundColor: state.isFocused
                                            ? "#eee"
                                            : "#fff",
                                        },
                                      }),
                                    }}
                                  />

                                  {formik.errors.country && (
                                    <p className="err">
                                      {formik.errors.country}
                                    </p>
                                  )}
                                </div>
                                <div
                                  className="inputBox mt-3"
                                  style={{
                                    position: "relative",
                                    marginTop: 0,
                                    marginBottom: "10px",
                                  }}
                                >
                                  <label
                                    htmlFor="state"
                                    className="semiFont login__label"
                                  >
                                    State {requiredField}
                                  </label>
                                  <Select
                                    value={{
                                      label: formik.values.state,
                                      value: formik.values.state,
                                    }}
                                    onChange={(p) => {
                                      getAllCities(p.value);
                                      formik.setFieldValue("state", p.value);
                                      formik.setFieldValue("city", null);
                                    }}
                                    // defaultValue=""
                                    options={states.map((s) => {
                                      return { value: s.name, label: s.name };
                                    })}
                                    onLoad={(p) => getAllCities(p.value)}
                                    id="inputDropdown"
                                    name="state"
                                    // className="admim__Addproduct--dropdown "
                                    placeholder="Select State"
                                    // id="state"
                                    styles={{
                                      control: (base, state) => ({
                                        ...base,
                                        marginTop: "5px",
                                        padding: "10px 10px",
                                        border: formik.errors.state
                                          ? "1px solid red"
                                          : "1px solid #c3cad9",
                                        "&:active": {
                                          outline: "none",
                                          boxShadow: "none",
                                        },
                                        "&:hover": {
                                          outline: "none",
                                          boxShadow: "none",
                                        },
                                      }),
                                      option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isFocused
                                          ? "#eee"
                                          : "#fff",
                                        padding: "8px",
                                        display: "flex",
                                        fontFamily: "semiFont",
                                        alignItems: "center",
                                        fontSize: "16px",
                                        zIndex: 9999,
                                        color: state.isFocused
                                          ? "#183b56"
                                          : "#183b56",
                                        "&:hover": {
                                          backgroundColor: state.isFocused
                                            ? "#eee"
                                            : "#fff",
                                        },
                                      }),
                                    }}
                                  />

                                  {formik.errors.state && (
                                    <p className="err">{formik.errors.state}</p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-12 p-0 mt-3">
                            <div className="row align-767  ">
                              <div className="col-lg-6 col-xl-6 col-md-6  col-12">
                                <div
                                  className="inputBox"
                                  style={{
                                    position: "relative",
                                    marginTop: 0,
                                    marginBottom: "10px",
                                  }}
                                >
                                  <label
                                    htmlFor="city"
                                    className="semiFont login__label"
                                  >
                                    City {requiredField}
                                  </label>
                                  <Select
                                    value={{
                                      label: formik.values.city,
                                      value: formik.values.city,
                                    }}
                                    onChange={(p) => {
                                      formik.setFieldValue("city", p.value);
                                    }}
                                    options={cities.map((c) => {
                                      return { value: c.name, label: c.name };
                                    })}
                                    id="inputDropdown"
                                    name="city"
                                    className="admim__Addproduct--dropdown "
                                    placeholder="Select City"
                                    // id="state"
                                    styles={{
                                      control: (base, state) => ({
                                        ...base,
                                        marginTop: "5px",
                                        padding: "10px 10px",
                                        border: formik.errors.city
                                          ? "1px solid red"
                                          : "1px solid #c3cad9",
                                        //   border: '1px solid red'
                                        "&:active": {
                                          outline: "none",
                                          boxShadow: "none",
                                        },
                                        "&:hover": {
                                          outline: "none",
                                          boxShadow: "none",
                                        },
                                      }),
                                      option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isFocused
                                          ? "#eee"
                                          : "#fff",
                                        padding: "8px",
                                        display: "flex",
                                        fontFamily: "semiFont",
                                        alignItems: "center",
                                        fontSize: "16px",
                                        zIndex: 9999,
                                        color: state.isFocused
                                          ? "#183b56"
                                          : "#183b56",
                                        "&:hover": {
                                          backgroundColor: state.isFocused
                                            ? "#eee"
                                            : "#fff",
                                        },
                                      }),
                                    }}
                                  />

                                  {formik.errors.city && (
                                    <p className="err">{formik.errors.city}</p>
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-6 col-xl-6 col-md-6  col-12">
                                {/* <div className="row align-items-center">
                          <div className="col-9 col-sm-8 justify-content-center"> */}
                                <div
                                  className="inputBox"
                                  style={{
                                    position: "relative",
                                    marginTop: 0,
                                    marginBottom: "10px",
                                  }}
                                >
                                  <label
                                    htmlFor="pincode"
                                    className="semiFont login__label"
                                  >
                                    Postalcode / ZIP {requiredField}
                                  </label>
                                  <input
                                    type="text"
                                    value={formik.values.pincode}
                                    onChange={(e) =>
                                      formik.setFieldValue(
                                        "pincode",
                                        e.currentTarget.value.replace(
                                          /[^\w\s]/gi,
                                          ""
                                        )
                                      )
                                    }
                                    style={{
                                      border: formik.errors.pincode
                                        ? "1px solid red"
                                        : "1px solid #c3cad9",
                                      marginTop: "5px",
                                      width: "auto",
                                      fontFamily: "mediumFont",
                                    }}
                                    id="pincode"
                                    placeholder="XXXXXX"
                                    aria-describedby="pincode"
                                    // placeholder=""
                                  />
                                  {formik.errors.pincode && (
                                    <p className="dashboard-errorPosition">
                                      {formik.errors.pincode}
                                    </p>
                                  )}
                                </div>
                                {/* </div>
                        </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-2 ml-2">
                          <Button
                            className={
                              formik.dirty
                                ? "primary__btn"
                                : "primary__btn--disabled"
                            }
                            type="contained"
                            style={{
                              padding: "8px 30px",
                              color: formik.dirty
                                ? "#fff"
                                : "rgba(0, 0, 0, 0.26)",
                            }}
                            disabled={!formik.dirty}
                            onClick={function (e) {
                              formik.handleSubmit();
                            }}
                          >
                            Update
                          </Button>
                        </div>
                      </div>
                    ) : null}

                    {active === 2 ? (
                      <div className="active__container mt-4">
                        {/* <> */}
                        <div className="col-12 p-0 ">
                          <div className="row ">
                            <div className="col-lg-6 col-xl-6 col-md-6  col-12">
                              <div
                                className="inputBox"
                                style={{
                                  position: "relative",
                                  marginTop: 0,
                                  marginBottom: "10px",
                                }}
                              >
                                <label
                                  htmlFor="oldPassword"
                                  className="semiFont login__label"
                                >
                                  Old Password {requiredField}
                                </label>
                                <input
                                  type="text"
                                  maxLength={15}
                                  value={formik.values.oldPassword}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "oldPassword",
                                      e.currentTarget.value.replace(
                                        /[^a-zA-Z0-9@]/g,
                                        ""
                                      )
                                    );
                                  }}
                                  style={{
                                    border: formik.errors.oldPassword
                                      ? "1px solid red"
                                      : "1px solid #c3cad9",
                                    marginTop: "5px",
                                    width: "auto",
                                  }}
                                  id="oldPassword"
                                  aria-describedby="oldPassword"
                                  placeholder="Old password"
                                />
                                {formik.errors.oldPassword && (
                                  <p className="err">
                                    {formik.errors.oldPassword}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-6 col-xl-6 col-md-6  col-12">
                              <div
                                className="inputBox"
                                style={{
                                  position: "relative",
                                  marginTop: 0,
                                  marginBottom: "10px",
                                }}
                              >
                                <label
                                  htmlFor="newPassword"
                                  className="semiFont login__label"
                                >
                                  New Password {requiredField}
                                </label>
                                <input
                                  type={securetext ? "password" : "text"}
                                  maxLength={15}
                                  value={formik.values.newPassword}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "newPassword",
                                      e.currentTarget.value.replace(
                                        /[^a-zA-Z0-9@]/g,
                                        ""
                                      )
                                    );
                                  }}
                                  style={{
                                    border: formik.errors.newPassword
                                      ? "1px solid red"
                                      : "1px solid #c3cad9",
                                    marginTop: "5px",
                                    width: "auto",
                                  }}
                                  id="newPassword"
                                  aria-describedby="newPassword"
                                  placeholder="New password"
                                />
                                <div
                                  className="signuppwd__icon"
                                  onClick={(e) =>
                                    securetext
                                      ? setSecuretext(false)
                                      : setSecuretext(true)
                                  }
                                >
                                  <IconContext.Provider
                                    value={{
                                      color: "#959EAD",
                                      size: "20px",
                                    }}
                                  >
                                    {securetext ? <VscEye /> : <VscEyeClosed />}
                                  </IconContext.Provider>
                                </div>

                                {formik.errors.newPassword && (
                                  <p className="err">
                                    {formik.errors.newPassword}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-6 col-xl-6 col-md-6  col-12">
                              <div
                                className="inputBox"
                                style={{
                                  position: "relative",
                                  marginTop: 0,
                                  marginBottom: "10px",
                                }}
                              >
                                <label
                                  htmlFor="confirmPwd"
                                  className="semiFont login__label"
                                >
                                  Confirm Password {requiredField}
                                </label>
                                <input
                                  type={securetext2 ? "password" : "text"}
                                  maxLength={15}
                                  value={formik.values.confirmPwd}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "confirmPwd",
                                      e.currentTarget.value.replace(
                                        /[^a-zA-Z0-9@]/g,
                                        ""
                                      )
                                    );
                                  }}
                                  style={{
                                    border: formik.errors.confirmPwd
                                      ? "1px solid red"
                                      : "1px solid #c3cad9",
                                    marginTop: "5px",
                                    width: "auto",
                                  }}
                                  id="confirmPwd"
                                  aria-describedby="confirmPwd"
                                  placeholder="Confirm passsword"
                                />
                                <div
                                  className="signuppwd__icon"
                                  onClick={(e) =>
                                    securetext2
                                      ? setSecuretext2(false)
                                      : setSecuretext2(true)
                                  }
                                >
                                  <IconContext.Provider
                                    value={{
                                      color: "#959EAD",
                                      size: "20px",
                                    }}
                                  >
                                    {securetext2 ? (
                                      <VscEye />
                                    ) : (
                                      <VscEyeClosed />
                                    )}
                                  </IconContext.Provider>
                                </div>

                                {formik.errors.confirmPwd && (
                                  <p className="err">
                                    {formik.errors.confirmPwd}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="mt-2 ml-2">
                            <Button
                              className={
                                formik.dirty
                                  ? "primary__btn"
                                  : "primary__btn--disabled"
                              }
                              type="contained"
                              style={{
                                padding: "8px 30px",
                                color: formik.dirty
                                  ? "#fff"
                                  : "rgba(0, 0, 0, 0.26)",
                              }}
                              disabled={!formik.dirty}
                              onClick={function (e) {
                                formik.handleSubmit();
                              }}
                            >
                              Update
                            </Button>
                          </div>

                          {/* <div className="row mb-3 mt-3">
                            <div className=" col-11 offset-1 col-sm-10 offset-sm-2 col-md-12 offset-md-0">
                              <Button
                                variant="contained"
                                color="primary"
                                disabled={formik.isSubmitting || !formik.dirty}
                                onClick={function (e) {
                                  formik.validateForm();
                                  return formik.dirty && formik.isValid
                                    ? formik.handleSubmit(e)
                                    : null;
                                }}
                                className={
                                  formik.dirty && !formik.isSubmitting
                                    ? "signup__button"
                                    : "signup__buttondisabled"
                                }
                                style={{ padding: "5px 50px" }}
                                //   disabled={true}
                              >
                                Save/Update
                              </Button>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    ) : null}
                  </>
                );
                // );
              }}
            </Formik>
          </>
        </section>
      </>
    </>
  );
};

export default Settings;
